import { Card } from "antd";
import React from "react";

export default function BlockAndBuildingInfoCard({ propertyUprn, blockInfo }) {
  const blockUprn = blockInfo.blockUprn;
  const blockProperties = blockInfo.blockProperties;

  if (blockProperties.length === 0) {
    return (<Card size="large" id="property-building-info-card" className="App-property-card" title="Other properties in the same building">
      <p>This property doesn&rsquo;t share its building with any other addresses.</p>
    </Card>);
  }

  const propertyRows = blockProperties.map(property => {
    const isCurrent = property.uprn === propertyUprn;

    return (
      <li key={ property.uprn } className={ isCurrent ? "Block-property Block-property-current" : "Block-property" }>
        <span className="Block-property-uprn">{ property.uprn }</span>
        <span>{ property.single_line_address }</span>
        { isCurrent && <span className="Block-property-badge">This property</span> }
      </li>);
  });

  return (<Card size="large" id="property-building-info-card" className="App-property-card" title="Other properties in the same building">
    <p className="Block-summary">
      <span><span style={ { fontWeight: 'bold' } }>Block UPRN</span> { blockUprn }</span>
      <span>{ blockProperties.length.toLocaleString() } properties share this building</span>
    </p>
    <ul className="Block-properties">
      { propertyRows }
    </ul>
  </Card>);
}
